import { EN } from './en';
import { DE } from './de';
const labels = {
    en: EN,
    de: DE,
};
export default labels;
